import { PaymentDomainService } from './domain';
import { NurseryId } from './entity/valueObjects/nurseryId';

import type { PublicApiSettingsIRepository } from './entity/publicApiSettingsIRepository';
import type { PaymentSquareApi } from '@/infra/paymentSquareApi';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';

/**
 * 支払アプリケーションサービス
 */
export class PaymentApplicationService {
  private service: PaymentDomainService;

  constructor() {
    this.service = new PaymentDomainService();
  }

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param paymentSquareApi paymentSquareApi
   * @param publicApiSettingsRepository publicApiSettingsRepository
   */
  inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    paymentSquareApi: PaymentSquareApi,
    publicApiSettingsRepository: PublicApiSettingsIRepository,
  ) {
    this.service.inject(
      wagakoNurseryApi,
      paymentSquareApi,
      publicApiSettingsRepository,
    );
  }

  /**
   * getApiSettings
   * @param nurseryId nurseryId
   * @returns 結果
   */
  async getApiSettings(nurseryId: string) {
    // Apiで読み込んでEntityとして返す
    const result = await this.service.getApiSettings(NurseryId.create(nurseryId));
    return result?.toJsonData();
  }

  /**
   * UIにカード支払いフォームを埋め込む
   * @param id id
   * @param selectorOrElement UIのID
   * @returns エラー
   */
  attachCreditCard(
    id: {
      appId: string;
      locationId: string;
    },
    selectorOrElement: string,
  ) {
    return this.service.attachCreditCard(id, selectorOrElement);
  }

  /**
   * クレジットカード情報をトークン化する.
   * @returns 結果
   */
  tokenizeCreditCard() {
    return this.service.tokenizeCreditCard();
  }

  /**
   * createCreditCard
   * @param nurseryId nurseryId
   * @param sourceId sourceId
   * @returns 結果
   */
  createCreditCard(nurseryId: string, sourceId: string) {
    return this.service.createCreditCard(nurseryId, sourceId);
  }

  /**
   * getCreditCardList
   * @param nurseryId nurseryId
   * @returns 結果
   */
  getCreditCardList(nurseryId: string) {
    return this.service.getCreditCardList(nurseryId);
  }
}
